export const ARIA_LABEL_NAMESPACE = 'ariaLabels';
export const ARIA_LABEL_KEY =
  'verticalAnchorsMenu_AriaLabel_TopLevel_Navigation';
export const ARIA_LABEL_DEFAULT = 'Page';
export const ARIA_LABELLED_BY_PREFIX = 'anchor-label_';
